export type NegotiationPropertySummary = {
  code?: string | null
  name?: string | null
}

function propertyLabel(property?: NegotiationPropertySummary | null): string {
  return [property?.code, property?.name].filter(Boolean).join(' · ')
}

export function resolveNegotiationProperty(
  property?: NegotiationPropertySummary | null,
  previousProperty?: NegotiationPropertySummary | null
) {
  const activeLabel = propertyLabel(property)
  const historicalLabel = propertyLabel(previousProperty)

  if (activeLabel) {
    return { label: activeLabel, isHistorical: false }
  }
  if (historicalLabel) {
    return { label: historicalLabel, isHistorical: true }
  }
  return { label: 'Sin inmueble asignado', isHistorical: false }
}
